// import ReactDOM from 'react-dom'
import React from "react";
import { BrowserRouter as Router, StaticRouter, Route } from "react-router-dom";
import Index from "venuescanner-js/react/components/VirtualEvents/pages";
import Events from "venuescanner-js/react/components/VirtualEvents/pages/events";
// import isSSR from 'venuescanner-js/services/isSSR'
// const {
//   BrowserRouter
// } = isSSR ? null : import('react-router-dom')

const VirtualEvents = () => {
  return (
    <>
      <Route exact path="/virtual-events">
        <Index />
      </Route>
      <Route exact path="/virtual-events/:category" component={Events} />
    </>
  );
};
export const hydrate = () => {
  return (
    <Router>
      <VirtualEvents />
    </Router>
  );
};

// ReactDOM.render(<VirtualEvents />, document.getElementById('virtual-events'))

export default () => {
  return (
    <StaticRouter location={"/virtual-events"}>
      <VirtualEvents />
    </StaticRouter>
  );
};
